import { render, staticRenderFns } from "./SampleRequestDetail.vue?vue&type=template&id=c54b86fa"
import script from "./SampleRequestDetail.vue?vue&type=script&lang=js"
export * from "./SampleRequestDetail.vue?vue&type=script&lang=js"
import style0 from "./SampleRequestDetail.vue?vue&type=style&index=0&id=c54b86fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports